import fetchPostRedRestApi from "../services/fetch-post-red-rest-api";

export default () => ({
    isLoading: false,
    confirmModalIsOpen: false,
    courseId: 0,
    userId: 0,

    init() {
        this.courseId = this.$root.dataset.courseId ?? 0
        this.userId = this.$root.dataset.userId ?? 0
    },

    openConfirmModal() {
        this.confirmModalIsOpen = true
    },

    closeConfirmModal() {
        this.confirmModalIsOpen = false
    },

    async retakeCourse() {
        try {
            this.isLoading = true

            const {success, message} = await fetchPostRedRestApi('retake-course', {
                courseId: this.courseId,
                userId: this.userId
            })

            if (success) {
                window.location.reload()
            }
        } catch (error) {
            console.error(error)
        } finally {
            this.isLoading = false
            this.closeConfirmModal()
        }
    }
})